<div class="wrapper">
    <div class="sidebar-wrapper">
        <div class="sidebar-wrapper-header mt-3">
            <img class="logo" src="../../../../../assets/images/incucai-logo.png" alt="" />
        </div>
         <div class="user-info mt-3">
            {{'documentsGrid.name' | translate}}: {{ this.currentUser?.name }} <br>
            <ng-container *ngIf="isPatient; else notPatient">
                {{'documentsGrid.role' | translate}}: {{ loadUserInfo() }} <br>
            </ng-container>
            <ng-template #notPatient>
                {{'documentsGrid.role' | translate}}: {{ this.currentUser?.currentRole }} <br>
                Org: {{ loadUserInfo() }}
            </ng-template>
        </div>
        <div class="items-wrapper">
            <div class="items-wrapper-top">
                <div class="item" [routerLink]="'documents/'">
                    <i class="fa fa-file icon" aria-hidden="true"></i>
                    {{'documentsGrid.pageTitle' | translate}}
                </div>
                <div class="item" [routerLink]="'verification/'">
                    <i class="fa fa-shield icon" aria-hidden="true"></i>
                    {{'verification.pageTitle' | translate}}
                </div>
                <div *ngIf="currentUser?.organization.isParentOrganization" class="item" [routerLink]="'users/patients'">
                    <i class="fa fa-users icon" aria-hidden="true"></i>
                    {{'landingPage.patients' | translate}}
                </div>
            </div>
            <div class="items-wrapper-rsk" style="margin-top: auto;">
                <img class="logo" src="../../../../../assets/images/rsk_cuted.png" alt="" />
            </div>

            <div class="items-wrapper-bottom">
                <div class="item item-exit" (click)="logout()">
                    <i class="fa fa-sign-out icon"></i>
                    {{ "landingPage.Logout" | translate }}
                </div>
            </div>
        </div>
    </div>

    <div class="content">
        <router-outlet></router-outlet>
    </div>
</div>